import axios from "axios";
import { parseJwt } from "../Utils";

class DataManager
{
    constructor(serverURL) {
        this.serverURL = serverURL;
    }

    async validateManual(emailAddress, confirmationCode) {
        let formData = new FormData();
        formData.append("EmailAddress", emailAddress);
        formData.append("ConfirmationCode", confirmationCode);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/validate", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                // if (response.data.data.jwt) {
                //     sessionStorage.setItem("tokenData", parseJwt(response.data.data.jwt));
                // }
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
                /*
                if (typeof error.response.data !== "undefined")
                {
                    return error.response.data;
                }
                 */
            });
    }

    async validateAuto(personID, confirmationCode) {
        let formData = new FormData();
        formData.append("PersonID", personID);
        formData.append("ConfirmationCode", confirmationCode);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/validate", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                // if (response.data.data.jwt) {
                //     sessionStorage.setItem("tokenData", parseJwt(response.data.data.jwt));
                // }
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }


    async resendEmail(emailAddress, firstName, lastName) {
        let formData = new FormData();
        formData.append("FirstName", firstName);
        formData.append("LastName", lastName)
        formData.append("EmailAddress", emailAddress);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/resend", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }

    async submit(jwt, croppedPhoto, password)
    {
        // console.log(jwt);
        // console.log(croppedPhoto);
        // console.log(password);

        let fileName = "photo.png";
        if (croppedPhoto.type === "image/jpeg")
        {
            fileName = "photo.jpg";
        }

        let formData = new FormData();
        formData.append("jwt", jwt);
        formData.append("PhotoFile", croppedPhoto, fileName);
        formData.append("Password", password);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/submit", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }

    async fetchTerms(collectionID)
    {
        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.get(this.serverURL + "/public/terms/" + collectionID, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
                /*
                if (typeof error.response.data !== "undefined")
                {
                    return error.response.data;
                }
                 */
            });
    }

    async updateName(jwt, firstName, LastName) {
        let formData = new FormData();
        formData.append("jwt", jwt);
        formData.append("FirstName", firstName);
        formData.append("LastName", LastName);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/updatename", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
                /*
                if (typeof error.response.data !== "undefined")
                {
                    return error.response.data;
                }
                 */
            });
    }

    async updateAliases(jwt, aliases, country) {
        let formData = new FormData();
        formData.append("jwt", jwt);
        formData.append("Aliases", JSON.stringify(aliases));
        formData.append("Country", country);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/updatealiases", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
                /*
                if (typeof error.response.data !== "undefined")
                {
                    return error.response.data;
                }
                 */
            });
    }

    async updatePhoto(jwt, croppedPhoto)
    {
        // console.log(jwt);
        // console.log(croppedPhoto);
        // console.log(password);

        let fileName = "photo.png";
        if (croppedPhoto.type === "image/jpeg")
        {
            fileName = "photo.jpg";
        }

        let formData = new FormData();
        formData.append("jwt", jwt);
        formData.append("PhotoFile", croppedPhoto, fileName);

        let systemDialectID = sessionStorage.getItem("SystemDialectID");

        return await axios.post(this.serverURL + "/register-api/updatePhoto", formData, {headers: {"Systemdialectid": systemDialectID}})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }
}

export default DataManager;